import {NgModule, StaticProvider} from '@angular/core';
import {BrowserModule} from "@angular/platform-browser";
import {platformBrowserDynamic} from "@angular/platform-browser-dynamic";
import {downgradeModule} from "@angular/upgrade/static";
import {NgbModule} from "@ng-bootstrap/ng-bootstrap";
import {TranslateModule} from "@ngx-translate/core";
import {WidgetContainerComponent} from "./components/widget-container/widget-container.component";
import {CommonsModule} from "../../commons/angular/commons.module";
import {NgxPermissionsModule} from "ngx-permissions";
import {DashboardViewComponent} from "./components/dashboard-view/dashboard-view.component";
import {DragDropModule} from "@angular/cdk/drag-drop";
import {ScrollingModule} from "@angular/cdk/scrolling";
import {AgentProgressTableRowComponent} from "./components/agent-progress-table-row/agent-progress-table-row.component";
import {AccountsModule} from "../../account/angular/accounts.module";
import {AddressesModule} from "../../addresses/angular/addresses.module";
import {AgentsModule} from "../../agents/angular/agents.module";
import {ServicesModule} from "../../deliveries/angular/services.module";
import {
  AgentProgressTableWidgetComponent
} from "./components/agent-progress-table-widget/agent-progress-table-widget.component";
import {MapModule} from "../../map/angular/map.module";
import {
  DashboardAgentsTableViewComponent
} from "./components/dashboard-agents-table-view/dashboard-agents-table-view.component";
import {DashboardAgentsTableComponent} from "./components/dashboard-agents-table/dashboard-agents-table.component";
import {
  DashboardServicesTableViewComponent
} from "./components/dashboard-services-table-view/dashboard-services-table-view.component";
import {
  DashboardServicesTableComponent
} from "./components/dashboard-services-table/dashboard-services-table.component";
import {Gridster, GridsterItem} from "angular-gridster2";
import {
  DashboardAgentsRouteScoreTableViewComponent
} from "./components/dashboard-agents-route-score-table-view/dashboard-agents-route-score-table-view.component";
import {
  DashboardAgentsRouteScoreTableComponent
} from "./components/dashboard-agents-route-score-table/dashboard-agents-route-score-table.component";
import {AgentSequenceScoreComponent} from "./components/agent-sequence-score/agent-sequence-score.component";
import {
  DashboardAgentsRouteScoreTableRowComponent
} from "./components/dashboard-agents-route-score-table-row/dashboard-agents-route-score-table-row.component";
import {
  AgentsRouteScoreExpandableTableComponent
} from "./components/agents-route-score-expandable-table/agents-route-score-expandable-table.component";
import {TasksModule} from "../../tasks/angular/tasks.module";
import {
  AgentsRouteScoreExpandableTableRowComponent
} from "./components/agents-route-score-expandable-table-row/agents-route-score-expandable-table-row.component";
import {ScrollingModule as ScrollingModuleExperimental} from "@angular/cdk-experimental/scrolling";
import {
  AgentRoutesPerformanceRowComponent
} from "./components/agent-routes-performance-row/agent-routes-performance-row.component";

@NgModule({
  declarations: [
    DashboardViewComponent,
    WidgetContainerComponent,
    AgentProgressTableWidgetComponent,
    AgentProgressTableRowComponent,
    DashboardAgentsTableViewComponent,
    DashboardAgentsTableComponent,
    DashboardServicesTableViewComponent,
    DashboardServicesTableComponent,
    DashboardAgentsRouteScoreTableViewComponent,
    DashboardAgentsRouteScoreTableComponent,
    AgentSequenceScoreComponent,
    DashboardAgentsRouteScoreTableRowComponent,
    AgentsRouteScoreExpandableTableComponent,
    AgentsRouteScoreExpandableTableRowComponent,
    AgentRoutesPerformanceRowComponent
  ],
  imports: [
    BrowserModule,
    CommonsModule,
    ScrollingModule,
    NgbModule,
    TranslateModule.forChild(),
    NgxPermissionsModule,
    DragDropModule,
    AccountsModule,
    AddressesModule,
    AgentsModule,
    ServicesModule,
    MapModule,
    Gridster,
    GridsterItem,
    TasksModule,
    ScrollingModuleExperimental
  ],
  providers: [],
  exports: [
    AgentRoutesPerformanceRowComponent
  ]
})

export class DashboardsModule {
  constructor() {
  }

  ngDoBootstrap() {
  }
}

const bootstrapDashboardsModule = (extraProviders: StaticProvider[]) => {
  const platformRef = platformBrowserDynamic(extraProviders);
  return platformRef.bootstrapModule(DashboardsModule);
};

export const downgradedDashboardsModule = downgradeModule(bootstrapDashboardsModule);
